
export default [
    {
        id:"sidebar.menu",
        title:"侧边栏菜单",
        description:"追加侧边栏菜单项",
        handler:()=> import("./sidebar.menu/handler")
    }
];